import React from 'react';
import { Marquee } from './Marquee';
export function Footer() {
  return <footer className="relative bg-otter-black pt-16" data-id="element-163">
      <div className="container mx-auto px-4 pb-16" data-id="element-164">
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row" data-id="element-165">
          <div className="flex items-center gap-4" data-id="element-166">
            <img src="https://cdn.magicpatterns.com/uploads/4HX4fnnnRHUFQ1DwVQMuBe/37.png" alt="Logo" className="h-16 w-16 rounded-full border-2 border-otter-cyan" data-id="element-167" />
            <div data-id="element-168">
              <h2 className="font-display text-3xl tracking-widest text-otter-bone" data-id="element-169">
                OTTER
              </h2>
              <p className="font-display text-sm tracking-wider text-otter-cyan" data-id="element-170">
                GRILL CLEANING
              </p>
            </div>
          </div>

          <div className="flex gap-8 font-display text-xl tracking-wider text-otter-bone/60" data-id="element-171">
            <a href="#services" className="hover:text-otter-cyan" data-id="element-172">
              SERVICES
            </a>
            <a href="#gallery" className="hover:text-otter-cyan" data-id="element-173">
              GALLERY
            </a>
            <a href="#about" className="hover:text-otter-cyan" data-id="element-174">
              ABOUT
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between border-t-2 border-otter-bone/10 pt-8 text-center md:flex-row md:text-left" data-id="element-175">
          <p className="font-body text-sm text-otter-bone/40" data-id="element-176">
            © {new Date().getFullYear()} Otter Grill Cleaning. All rights
            reserved.
          </p>
          <p className="mt-2 font-accent text-lg text-otter-bone/40 md:mt-0" data-id="element-177">
            Keep it clean.
          </p>
        </div>
      </div>

      <div className="w-full border-t-4 border-otter-black bg-otter-cyan py-2" data-id="element-178">
        <Marquee text="OTTER GRILL CLEANING • OTTER GRILL CLEANING •" speed={25} className="font-display text-xl text-otter-black" data-id="element-179" />
      </div>
    </footer>;
}